// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"6bec34b4","458":"92f70182","591":"41eea658","605":"af1b6c62","700":"b78a1208","840":"c451f89b","859":"be5c643e","946":"1301c922"}[chunkId] + ".chunk.js";
};